import React, { useEffect, useState } from "react";
import { ActiveClientCount, StatisticsModel } from "../../core/api/statistics/StatisticsModel";
import { 
  DataGrid, 
  GridColDef, 
} from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";

const ActiveClientCountsTable: React.FC = () => {
  const [data, setData] = useState<ActiveClientCount[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const stats = await StatisticsModel.getActiveClientStats();
      setData(stats);
    };

    fetchData().catch(console.error);
  }, []);

  // Prepare rows with IDs for DataGrid
  const rows = data.map((item, index) => ({ ...item, id: index }));

  const columns: GridColDef[] = [
    {
      field: "date",
      headerName: "Data",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "count",
      headerName: "Klientų skaičius",
      flex: 1,
      type: "number",
    },
  ];

  return (
    <Box sx={{ 
      width: '100%', 
      height: '100%', 
      bgcolor: 'background.paper',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Box sx={{ 
        p: 2, 
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}>
        <Typography variant="h6">
          Aktyvūs klientai pagal mėnesius
        </Typography>
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableRowSelectionOnClick
          disableColumnFilter
          disableColumnMenu
          hideFooter
          getRowClassName={(params) => 
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : ''
          }
          sx={{
            border: 'none',
            '& .even-row': {
              backgroundColor: '#efefef',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#bdbdbd',
              borderBottom: '1px solid',
              borderColor: 'divider',
            },
            '& .MuiDataGrid-virtualScroller': {
              minHeight: '200px',
            },
            '& .MuiDataGrid-cell': {
              borderBottom: 'none',
            },
            '& .MuiDataGrid-row': {
              borderBottom: '1px solid',
              borderColor: 'divider',
            },
            maxHeight: '600px',

          }}
          slots={{
            noRowsOverlay: () => (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                Aktyvių klientų statistikos nėra
              </Box>
            ),
          }}
        />
      </Box>
    </Box>
  );
};

export default ActiveClientCountsTable;
